module.exports = __webpack_public_path__ + "static/media/sig.fcdd320f.png";